import React, { useState, useEffect, useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { endpointContext } from '../contexts/endpointContext';

export const Users = (props) => {
	const [users, setUsers] = useState([]);
	const [searchUser, setSearchUser] = useState('');

	const endpointContextUsers = useContext(endpointContext);

	useEffect(() => {
		setUsers(endpointContextUsers.dbData.qcUsers);
	}, [endpointContextUsers.dbData.qcUsers]);

	return (
		<>
			{props.authProps.isAuthenticated ? (
				<div className="col px-0">
					<div className="contentContainer">
						<hr style={{ marginTop: '58px' }}></hr>
						<h2>QC Users</h2>
						<h5>Use this page to view the users allowed to perform QC</h5>
						<br></br>
						<h5>Search for user</h5>
						<div className="d-flex justify-content-start">
							<input
								type="text"
								style={{ width: '200px' }}
								className="form-control"
								value={searchUser}
								onChange={(e) => setSearchUser(e.target.value)}
							></input>{' '}
							<button
								type="button"
								class="btn-close btn-sm pt-3 ms-2"
								aria-label="Close"
								onClick={() => setSearchUser('')}
							></button>
						</div>

						<div className="my-4">
							<h5>
								Admin Users (
								{users &&
									users.length > 0 &&
									users.filter((user) => {
										const isAdmin = user.userRole === 'admin';
										if (searchUser.length === 0) return isAdmin;

										const search = searchUser.trim().toLowerCase();

										const matchesSearch =
											(user.givenName || '').toLowerCase().includes(search) ||
											(user.familyName || '').toLowerCase().includes(search) ||
											(user.email || '').toLowerCase().includes(search);
										return isAdmin && matchesSearch;
									}).length}
								)
							</h5>
							<div className="table">
								<table className="captureTable">
									<thead>
										<tr>
											<th>Name</th>
											<th>Email</th>
											<th>Role</th>
											<th>Organisation</th>
											<th>Can QC</th>
										</tr>
									</thead>

									<tbody>
										{users &&
											users.length > 0 &&
											users
												.filter((user) => {
													const isAdmin = user.userRole === 'admin';
													if (searchUser.length === 0) return isAdmin;

													const search = searchUser.trim().toLowerCase();

													const matchesSearch =
														(user.givenName || '')
															.toLowerCase()
															.includes(search) ||
														(user.familyName || '')
															.toLowerCase()
															.includes(search) ||
														(user.email || '').toLowerCase().includes(search);
													return isAdmin && matchesSearch;
												})
												.map((user, idx) => (
													<tr key={idx}>
														<td>
															{user.givenName} {user.familyName}
														</td>
														<td>{user.email}</td>
														<td>{user.userRole}</td>
														<td>{user.organisation}</td>
														<td>
															<i className="fa-regular fa-circle-check"></i>
														</td>
													</tr>
												))}
									</tbody>
								</table>
							</div>
						</div>
						<div className="my-2">
							<h5>Super Users (
								{users &&
									users.length > 0 &&
									users.filter((user) => {
										const isSuperUser = user.userRole === 'superUser';
										if (searchUser.length === 0) return isSuperUser;

										const search = searchUser.trim().toLowerCase();

										const matchesSearch =
											(user.givenName || '').toLowerCase().includes(search) ||
											(user.familyName || '').toLowerCase().includes(search) ||
											(user.email || '').toLowerCase().includes(search);
										return isSuperUser && matchesSearch;
									}).length}
								)</h5>
							<div className="table">
								<table className="captureTable">
									<thead>
										<tr>
											<th>Name</th>
											<th>Email</th>
											<th>Role</th>
											<th>Organisation</th>
											<th>Can QC</th>
										</tr>
									</thead>

									<tbody>
										{users &&
											users.length > 0 &&
											users
												.filter((user) => {
													const isSuperUser = user.userRole === 'superUser';
													if (searchUser.length === 0) return isSuperUser;

													const search = searchUser.trim().toLowerCase();

													const matchesSearch =
														(user.givenName || '')
															.toLowerCase()
															.includes(search) ||
														(user.familyName || '')
															.toLowerCase()
															.includes(search) ||
														(user.email || '').toLowerCase().includes(search);
													return isSuperUser && matchesSearch;
												})
												.map((user, idx) => (
													<tr key={idx}>
														<td>
															{user.givenName} {user.familyName}
														</td>
														<td>{user.email}</td>
														<td>{user.userRole}</td>
														<td>{user.organisation}</td>
														<td>
															<i className="fa-regular fa-circle-check"></i>
														</td>
													</tr>
												))}
									</tbody>
								</table>
							</div>
						</div>
						{/* <div className="my-2">
							<h5>Users</h5>
							<div className="table">
								<table className="captureTable">
									<thead>
										<tr>
											<th>Name</th>
											<th>Email</th>
											<th>Role</th>
                                            <th>Organisation</th>
                                            <th>Can QC</th>
										</tr>
									</thead>

									<tbody>
										{users.length > 0 &&
											users
												.filter((user) => user.userRole === 'user')
												.map((user, idx) => (
													<tr>
														<td>
															{user.givenName} {user.familyName}
														</td>
														<td>{user.email}</td>
														<td>{user.userRole}</td>
                                                        <td>{user.organisation}</td>
                                                        <td><i className="fa-regular fa-circle-xmark"></i></td>
													</tr>
												))}
									</tbody>
								</table>
							</div>
						</div> */}
					</div>
				</div>
			) : (
				<Navigate to="/login" />
			)}
		</>
	);
};
